<template>
  <div class="container">
    <div class="success-wrapper">
      <img src="../assets/images/color-success.png" alt="" />
      <p>提交成功</p>
    </div>
    <div class="code-wrapper">
      <img src="../assets/images/code.png" alt="" />
    </div>
    <div class="desc-wrapper">
      <p v-if="!idStatus">长按扫码关注【希望学】公众号</p>
      <p v-else>截图扫码关注【希望学】公众号</p>
      <p>领取更多免费课程及学习资料</p>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.id = Number(this.$route.query.id);
  },
  computed: {
    idStatus() {
      return this.id === 2 || this.id === 7 || this.id === 8 || this.id === 9;
    },
  },
  data() {
    return {
      id: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 20px;
  height: 100vh;
  background: #fff;
  .success-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 5px;
    }
    p {
      font-size: 22px;
    }
  }
  .code-wrapper {
    width: 100%;
    margin: 30px 0;
    display: flex;
    justify-content: center;
    img {
      width: 220px;
      height: 220px;
    }
  }
  .desc-wrapper {
    p {
      margin: 0 0 5px;
      text-align: center;
    }
  }
}
</style>
